"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_ICON_CONFIGS = void 0;
exports.IconConverter = IconConverter;
exports.IconWrapper = IconWrapper;
var DEFAULT_ICON_CONFIGS = {
  size: '1em',
  strokeWidth: 1.5,
  strokeLinecap: 'round',
  strokeLinejoin: 'miter',
  rtl: false,
  theme: 'outline',
  colors: {
    outline: {
      fill: '#333333',
      background: 'transparent'
    }
  },
  prefix: 'kd'
};
exports.DEFAULT_ICON_CONFIGS = DEFAULT_ICON_CONFIGS;
function guid() {
  return 'icon-' + ((1 + Math.random()) * 0x100000000 | 0).toString(16).substring(1);
}
function IconConverter(id, icon, config) {
  var colors = '';
  var fill;
  if (icon.fill) {
    colors = typeof icon.fill === 'string' ? icon.fill : icon.fill;
  }
  var theme = icon.theme || config.theme;
  switch (theme) {
    case 'outline':
      break;
  }
  return {
    size: icon.size || config.size,
    strokeWidth: icon.strokeWidth || config.strokeWidth,
    strokeLinecap: icon.strokeLinecap || config.strokeLinecap,
    strokeLinejoin: icon.strokeLinejoin || config.strokeLinejoin,
    colors: colors,
    id: id
  };
}
function IconWrapper(name, rtl, _render) {
  var options = {
    name: 'icon-' + name,
    props: ['size', 'strokeWidth', 'strokeLinecap', 'strokeLinejoin', 'theme', 'fill', 'spin'],
    data: function data() {
      return {
        id: guid()
      };
    },
    inheritAttrs: false,
    render: function render(h) {
      var size = this.size,
        strokeWidth = this.strokeWidth,
        strokeLinecap = this.strokeLinecap,
        strokeLinejoin = this.strokeLinejoin,
        theme = this.theme,
        fill = this.fill,
        id = this.id,
        spin = this.spin,
        _this$ICON_CONFIGS = this.ICON_CONFIGS,
        ICON_CONFIGS = _this$ICON_CONFIGS === void 0 ? DEFAULT_ICON_CONFIGS : _this$ICON_CONFIGS;
      var svgProps = IconConverter(id, {
        size: size,
        strokeWidth: strokeWidth,
        strokeLinecap: strokeLinecap,
        strokeLinejoin: strokeLinejoin,
        theme: theme,
        fill: fill
      }, ICON_CONFIGS);
      var cls = ['kd-icon'];
      cls.push('kd-icon' + '-' + name);
      if (rtl && ICON_CONFIGS.rtl) {
        cls.push('kd-icon-rtl');
      }
      if (spin) {
        cls.push('kd-icon-spin');
      }
      return h("i", {
        "class": cls.join(' '),
        "style": {
          lineHeight: 0
        }
      }, [_render(h, svgProps)]);
    }
  };
  return options;
}